<form *ngIf="form" [formGroup]="form">

  <section>
    <app-input-array-group [sectionsLength]="this.type.configuration.splitter_sections.length" [max]="sections.length"
      [(groupSize)]="sectionsGroup" (groupSizeChange)="sectionsGroupChange($event)" groupName="Internal" i18n-groupName>
      <app-input-array #sectionsInput [values]="sections" (valuesChange)="sectionsChange($event)" i18n-label
        label="Section">
        <mat-error *ngIf="sectionsError" i18n>
          The splitter sections does not match with Access PON
        </mat-error>
      </app-input-array>
    </app-input-array-group>
    <app-suggestion *ngIf="sectionsInput.index != null" [options]="allowedSplitterValues"
      (changeSelection)="sections[sectionsInput.index]= $event">
    </app-suggestion>
  </section>

</form>
